import React, { useState } from "react";
import TextInput from "../shared/TextInput";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";

const StepThree = ({ control, handleChange, contact, setContact }) => {
  // ----------- hooks ------------
  const { t } = useTranslation();
  return (
    <div className="text-black">
      <h3 className="text-xl text-purple">{t("Third Step")}</h3>
      <h1 className="text-2xl font-semibold pb-5">
        {t("Additional Information")}
      </h1>
      <form action="">
        <div className="mb-14">
          <h2 className="text-xl pb-3 pb-4">{t("Contact Information")}</h2>
          <Controller
          name="activity"
          control={control}
          defaultValue={""}
          rules={{
            required: "First Name is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Activity")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="company_name"
          control={control}
          defaultValue={""}
          rules={{
            required: "Middle Name is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Company Name")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
          <Controller
          name="additional_info"
          control={control}
          defaultValue={""}
          rules={{
            required: "Middle Name is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Additional Information")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        </div>
      </form>
    </div>
  );
};

export default StepThree;
